<section class="admin-page ct-page ai-mkt" [class.ai-assistant-embedded]="embedded()">
  @if (!embedded()) {
    <app-ai-marketing-feature-header
      titleKey="aiMarketing.nav.assistant"
      subtitleKey="aiMarketing.assistant.subtitle"
    />
  }

  <div class="ct-card" [class.ai-assistant-panel-body]="embedded()">
    <div class="ai-assistant-scroll" #scrollHost>
      @if (turns().length === 0) {
        <div class="assistant-empty">
          <p class="muted">{{ 'aiMarketing.assistant.empty' | t }}</p>
          <div class="suggestions">
            @for (s of suggestions; track s) {
              <button type="button" class="chip" (click)="useSuggestion(s)">{{ s }}</button>
            }
          </div>
        </div>
      } @else {
        <div class="chat">
          @for (turn of turns(); track $index) {
            <div class="bubble" [class.user]="turn.role === 'user'" [class.assistant]="turn.role === 'assistant'">
              @if (turn.role === 'user') {
                <p class="bubble-text">{{ turn.content }}</p>
              } @else {
                <div class="bubble-body">
                  @for (line of displayAnswer(turn.content, !!turn.items?.length); track $index) {
                    <p class="bubble-summary">{{ line }}</p>
                  }

                  @if (turn.items?.length) {
                    <div class="assistant-items">
                      @for (item of turn.items; track item.permalink ?? item.title ?? $index) {
                        <article class="assistant-item">
                          @if (item.title) {
                            <div class="assistant-item-block">
                              <span class="assistant-item-label">{{ 'aiMarketing.assistant.content' | t }}</span>
                              <p class="assistant-item-content">{{ item.title }}</p>
                            </div>
                          }

                          <dl class="assistant-item-stats">
                            <div>
                              <dt>{{ 'aiMarketing.assistant.platform' | t }}</dt>
                              <dd>{{ item.platform }}</dd>
                            </div>
                            <div>
                              <dt>{{ 'aiMarketing.assistant.views' | t }}</dt>
                              <dd>{{ formatCount(item.views) }}</dd>
                            </div>
                            @if (item.reach !== null && item.reach !== undefined) {
                              <div>
                                <dt>{{ 'aiMarketing.assistant.reach' | t }}</dt>
                                <dd>{{ formatCount(item.reach) }}</dd>
                              </div>
                            }
                            @if (formatPostedAt(item.postedAt); as posted) {
                              <div>
                                <dt>{{ 'aiMarketing.assistant.posted' | t }}</dt>
                                <dd>{{ posted }}</dd>
                              </div>
                            }
                          </dl>

                          @if (resolvePublicationUrl(item.permalink); as href) {
                            <a
                              class="assistant-item-link"
                              [href]="href"
                              target="_blank"
                              rel="noopener noreferrer"
                              [title]="href"
                            >
                              <span class="material-symbols-outlined" aria-hidden="true">open_in_new</span>
                              {{ displayUrl(href) }}
                            </a>
                          }
                        </article>
                      }
                    </div>
                  } @else if (showMetrics(turn)) {
                    <dl class="assistant-metrics">
                      @for (m of turn.metrics; track m.label) {
                        <div class="assistant-metric">
                          <dt>{{ m.label }}</dt>
                          <dd>
                            {{ m.value }}
                            @if (m.context) {
                              <span class="muted">{{ m.context }}</span>
                            }
                          </dd>
                        </div>
                      }
                    </dl>
                  }
                </div>
              }
            </div>
          }

          @if (busy()) {
            <div class="bubble assistant assistant-pending" aria-live="polite">
              <span class="assistant-typing">{{ 'aiMarketing.assistant.thinking' | t }}</span>
            </div>
          }
        </div>
      }
    </div>

    <form class="ask-row ai-assistant-composer" (ngSubmit)="send()">
      <input
        class="ct-input"
        [ngModel]="question()"
        (ngModelChange)="question.set($event)"
        name="question"
        [placeholder]="'aiMarketing.assistant.placeholder' | t"
        [disabled]="busy()"
      />
      <button type="submit" class="ct-btn ct-btn-primary" [disabled]="busy() || !question().trim()">
        {{ 'aiMarketing.assistant.send' | t }}
      </button>
    </form>
  </div>
</section>
